// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WFBM","option":"styles_option__ZeBi6","selected":"styles_selected__wnpxH"};